export default __webpack_public_path__ + "static/media/Publimetro.11284fbd.jpg";